import axiosSetup from "../utils/axiosSetup";

export const addFrelitOrder = async (orderData: {
  goods: { productId: string; quantity: number }[];
}) => {
  try {
    const response = await axiosSetup.post(
      "frelitOrder/addFrelitOrder",
      orderData
    );
    // Return the order data directly from the response
    return response.data.data?.order || response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to create order");
  }
};

export const getFrelitOrders = async () => {
  try {
    const response = await axiosSetup.get("frelitOrder/getAllFrelitOrder");
    // Return the array of orders directly
    return response.data.data || response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to fetch orders");
  }
};